import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.string.small.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import classnames from 'classnames';
import { Input } from '../Input/Input';
import style from './FormattedInput.module.less';
/**
 * This is the base wrapper component that all
 * formatted inputs will compose.
 *
 * Note that this component shouldn't be used directly; similarly
 * to ActionBlock, consumers should rely on the exposed components
 * for what to use directly. For example, InputMoney.
 *
 * Note that the full set of react-number-props that are supported are at:
 *
 * https://github.com/s-yadav/react-number-format#props
 *
 */

export var FormattedInput = function FormattedInput(_ref) {
  var label = _ref.label,
      type = _ref.type,
      className = _ref.className,
      small = _ref.small,
      otherProps = _objectWithoutProperties(_ref, ["label", "type", "className", "small"]);

  return /*#__PURE__*/React.createElement(NumberFormat, _extends({
    className: classnames(className, _defineProperty({}, style['small-input'], small)),
    customInput: Input,
    decimalScale: 2,
    label: label,
    type: type
  }, otherProps));
};
FormattedInput.propTypes = {
  /**
   * Custom classes used for things like
   * spacing the component.
   */
  className: PropTypes.string,

  /**
   * Standard pattern HTML attribute that can
   * be used to restrict what's
   * available to mobile users via keyboard.
   *
   * Note that type="number" does not suffice
   * to restrict keyboard options. In the
   * currency input, InputMoney, we explicitly
   * set this to [0-9]* to restrict the digits
   * 0-9 on mobile keyboards.
   */
  pattern: PropTypes.string,

  /**
   * Flag to indicate if the formatted
   * input should be selectable.
   */
  disabled: PropTypes.bool,

  /**
   * Placeholder string that is set.
   */
  placeholder: PropTypes.string,

  /**
   * Descriptive text for the input. Inputs should always include a label.
   */
  label: PropTypes.string.isRequired,

  /**
   * Boolean flag to reduce the max width of the
   * input to a predefined value determined by
   * the design system.
   *
   * Used for wrapping components like ZIP and
   * Percent.
   */
  small: PropTypes.bool,

  /**
   * Mapping to the underlying <input>'s type
   * attribute. For example, type="tel"
   */
  type: PropTypes.string,

  /**
   * In general all input components should be controlled,
   * which means their value is passed into the component,
   * and state is maintained within the React component
   * as opposed to using refs from the DOM.
   *
   * Although generally required, default to ''.
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FormattedInput.defaultProps = {
  className: null,
  disabled: false,
  pattern: null,
  placeholder: null,
  small: false,
  type: 'text',
  value: ''
};